import { render, staticRenderFns } from "./WidgetPieGraph.vue?vue&type=template&id=8642e4f4&scoped=true&"
import script from "./WidgetPieGraph.vue?vue&type=script&lang=js&"
export * from "./WidgetPieGraph.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPieGraph.vue?vue&type=style&index=0&id=8642e4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8642e4f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8642e4f4')) {
      api.createRecord('8642e4f4', component.options)
    } else {
      api.reload('8642e4f4', component.options)
    }
    module.hot.accept("./WidgetPieGraph.vue?vue&type=template&id=8642e4f4&scoped=true&", function () {
      api.rerender('8642e4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetPieGraph.vue"
export default component.exports